module.exports = __webpack_public_path__ + "img/sceneIcon4-4.71736fdb.png";